module.exports = __webpack_public_path__ + "img/flag_100.33d61bdf.png";